import { callAPI } from './api.service';

export interface CleverAuthStatus {
  hasIntegration: boolean;
  isAuthenticated: boolean;
}

/**
 * Check if user has Clever integration
 */
export const checkCleverIntegration = async (): Promise<boolean> => {
  try {
    const response = await callAPI('api/auth/clever/status', null, 'GET');
    return response?.hasIntegration === true;
  } catch (error) {
    console.error('Error checking Clever integration:', error);
    return false;
  }
};

/**
 * Redirect to Clever authentication
 */
export const redirectToCleverAuth = (): void => {
  // Redirect to the Clever auth endpoint
  window.location.href = '/auth/clever';
};

/**
 * Get Clever authentication URL for popup
 */
export const getCleverAuthUrl = async (): Promise<string | null> => {
  try {
    const response = await callAPI('api/auth/clever/auth-url', null, 'GET');
    return response?.authUrl || null;
  } catch (error) {
    console.error('Error getting Clever auth URL:', error);
    return null;
  }
};
